module.exports = __webpack_public_path__ + "img/logo.00580c88.svg";